import React, { useState, useEffect } from 'react';
import CreatePool from './CreatePool';
import PoolView from './PoolView';
import { getPools } from '../../utils/api';
import CreateCasting from './Casting/CreateCasting';
import SearchBar from '../SeachBar';

const PoolUnit = () => {
  const [isCreatingPool, setIsCreatingPool] = useState(false); // State to toggle CreatePool view
  const [pools, setPools] = useState([]);
  const [selectedPool, setSelectedPool] = useState(null); // Track the selected pool
  const [isCreatingCasting, setIsCreatingCasting] = useState(false); // State to toggle CreateCastingView

  useEffect(() => {
    fetchPools();
  }, []);

  const fetchPools = async () => {
    try {
      const response = await getPools();
      setPools(response.data || []);
    } catch (err) {
      console.error('Error fetching pools:', err);
    }
  };

  const handlePoolClick = (pool) => {
    setSelectedPool(pool); // Set the selected pool
  };

  const handlePoolUpdated = async () => {
    await fetchPools(); // Refresh pools after creating or editing
    setIsCreatingPool(false);
    setIsCreatingCasting(false);
    setSelectedPool(null);
  };

  return (
    <div className="pool-list">
      <h1 className="title">Model Pools</h1>
      {isCreatingCasting ? (
        <CreateCasting onBack={handlePoolUpdated} pools={pools} />
      ) : isCreatingPool ? (
        <CreatePool onBack={handlePoolUpdated} pools={pools} />
      ) : selectedPool ? (
        <PoolView selectedPool={selectedPool} pools={pools} setSelectedPool={setSelectedPool} handlePoolUpdated={handlePoolUpdated} />
      ) : (
        <>
          <div style={{ textAlign: 'left' }}>
            <SearchBar optionalInfos={
              [<span key={"total"}>Total: 10</span>]}/>
            <button className="button" onClick={() => setIsCreatingPool(true)}>
              New Pool
            </button>
            <button className="button">Import Pool</button>
            <button className="button" onClick={() => setIsCreatingCasting(true)}>New Casting</button>
          </div>
          <div className="table">
            <div className="table-header">
              <span className="header-cell">Pool Name</span>
              <span className="header-cell">Amount of Models</span>
              <span className="header-cell">Model Categories</span>
            </div>
            {pools.map((pool, index) => (
              <div
                key={index}
                className="table-row"
                onClick={() => handlePoolClick(pool)}
                style={{ cursor: 'pointer' }}
              >
                <span className="table-cell">{pool.pool_id}</span>
                <span className="table-cell">{pool.model_count}</span>
                <span className="table-cell">{
                  pool.model_categories?.map((category, i) => (
                    <div key={`${index}, ${i}`}>{category},&nbsp;</div>
                  ))}
                </span>
              </div>
            ))}
          </div>
        </>
      )}
    </div>
  );
};

export default PoolUnit;
